// @flow

import React, { type Node } from 'react';

type HoverableProps = {
  children: ({ isHovered: boolean }) => Node,
  className?: string,
  tag: 'div' | 'span',
};

type HoverableState = {
  isHovered: boolean,
};

class Hoverable extends React.Component<HoverableProps, HoverableState> {
  static defaultProps = {
    tag: 'div',
  };

  state = {
    isHovered: false,
  };

  hover(isHovered: boolean) {
    this.setState({ isHovered });
  }

  render() {
    const { props } = this;
    const Tag = props.tag;
    return (
      <Tag
        className={props.className}
        onBlur={() => this.hover(false)}
        onFocus={() => this.hover(true)}
        onMouseEnter={() => this.hover(true)}
        onMouseLeave={() => this.hover(false)}
        tabIndex={0}
      >
        {props.children(this.state)}
      </Tag>
    );
  }
}

export default Hoverable;
